<template>
  <div class="bg-white">
    <div class="">
      <div class="relative">
        <marquee
          v-if="coachannounce[0].status == 'active'"
          class="bg-primary text-white absolute cust-marq lg:py-1 md:py-1"
        >
          {{ coachannounce[0].title || "static" }}
          <span class="ml-4">
            ⦁ {{ coachannounce[0].description1 || "static" }}</span
          >

          <span class="ml-4">
            ⦁ {{ coachannounce[0].description2 || "static" }}
          </span>
          <span class="ml-4">
            ⦁ Application closes by:
            {{
              new Date(coachannounce[0].closeDate).toDateString() || "static"
            }}
          </span>
        </marquee>
        <CoachSlider />
      </div>
      <div class="">
        <GridCards />
        <BecomeCoach />

        <div>
          <img
            src="@/assets/images/line/Frame 1000002302.png"
            alt="lineimg"
            class="m-auto mob-hidden"
          />
          <div
            class="lg:flex md:flex lg:w-full md:w-full lg:mb-0 md:mb-0 mb-0 sm-1350 lg:pt-0 md:pt-0 pt-12 w-full my-auto"
          >
            <TableContent />
            <TableInfo />
          </div>
        </div>

        <div class="">
          <h2 class="fsize36 sm-fsize25 text-center lg:mt-12 md:mt-8">
            Curriculum Overview
          </h2>
          <div
            class="w-full lg:flex md:flex flex col-reverse px-5 bg-white lg:pb-14 md:pb-14 py-4"
          >
            <div class="lg:w-1/2 md:w-1/2 w-full lg:px-12">
              <Collapse />
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full">
              <CollapseContent />
            </div>
          </div>

          <div class="lg:flex md:flex flex col-reverse items-center">
            <div
              class="lg:w-1/2 md:w-1/2 w-full lg:px-20 md:px-10 px-5 lg:py-16 md:py-16 lg:mt-0 md:mt-0 mt-8"
            >
              <LearningPackages />
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full">
              <ChildImage />
            </div>
          </div>
          <div
            class="lg:flex md:flex items-center lg:px-0 md:px-0 px-5 lg:mt-8 md:mt-8 mb-16"
          >
            <div
              class="lg:w-1/2 md:w-1/2 w-full lg:px-20 md:px-10 lg:py-8 md:py-8 relative"
            >
              <ClientImg />
            </div>
            <div
              class="lg:w-1/2 md:w-1/2 w-full lg:px-16 md:px-16 flex items-start"
            >
              <AboutFascilator />
            </div>
          </div>
        </div>
        <FormRegistration />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <Footer />
    </div>
  </div>
</template>
<script>
import FormRegistration from "./components/FormRegistration.vue";
import AboutFascilator from "./components/AboutFascilator.vue";
import ClientImg from "./components/ClientImg.vue";
import ChildImage from "./components/ChildImage.vue";
import LearningPackages from "./components/LearningPackages.vue";

import CollapseContent from "./components/CollapseContent.vue";
import Collapse from "./components/Collapse.vue";
import TableInfo from "./components/TableInfo.vue";
import TableContent from "./components/TableContent.vue";
import GridCards from "./components/GridCards.vue";
import CoachSlider from "./components/CoachSlider.vue";
import BecomeCoach from "./components/BecomeCoach.vue";
import Footer from "../Footer.vue";
import { mapState } from "vuex";

export default {
  components: {
    FormRegistration,
    AboutFascilator,
    ClientImg,
    ChildImage,
    LearningPackages,

    CollapseContent,
    Collapse,
    TableInfo,
    TableContent,
    GridCards,
    BecomeCoach,
    CoachSlider,
    Footer,
  },
  data() {
    return {
      handletime: [],
      items: [],
      sessiondate: "",
      mysessiondate: "",
      getmytime: "",
      mystartsession: "",
      myendsession: "",
    };
  },
  metaInfo: {
    title: "Become a Caregiver Coach - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Enroll for our 5 module learning programme. Certify as a Caregiver Coach. Lent your expertise as coach, pyscologist or therapist to support family caregivers.",
      },
    ],
  },
  methods: {
    getdatefun(mydate) {
      let newmydate = new Date(mydate);
      // return newmydate.toLocaleDateString();
      let month = newmydate.getMonth();
      let year = newmydate.getFullYear();
      let date = newmydate.getDate();

      let fixdate = date + "/" + month + "/" + year;
      return fixdate;
    },
    getMysession(mydate) {
      let newmydate = new Date(mydate);
      // return newmydate.toLocaleDateString();
      let month = newmydate.getMonth();
      let year = newmydate.getFullYear();
      let date = newmydate.getDate();
      let getmonth = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "Decembe",
      ];
      let fixdate = date + "th" + " " + getmonth[month] + " ,";
      return fixdate;
    },
    getDay(date) {
      let myday = new Date(date);
      let getmyday = myday.getDay();
      let weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return weekdays[getmyday];
    },
  },
  async mounted() {
    this.$store.dispatch("coach/getcoachtable");
    this.$store.dispatch("coach/getcoachannonce");
    await this.$store.dispatch("coach/GetSession");
    let sessiondata = this.coachsession.length - 1;
    this.sessiondate = this.coachsession[sessiondata].date;

    this.mystartsession = this.coachsession[0].starttime;
    this.myendsession = this.coachsession[0].endtime;

    this.coachsession.forEach((y) => {
      this.handletime.push({
        date: this.getdatefun(y.date),
        day: this.getDay(y.date),
        start: y.starttime,
        end: y.endtime,
      });
      this.mysessiondate = this.mysessiondate + " " + this.getMysession(y.date);
    });
    // this.$store.dispatch("coach/getcoachannonce");
    // this.init();
    // console.log(this.coachannounce)
  },
  computed: {
    ...mapState("coach", {
      coachannounce: "coachannounce",
    }),
    ...mapState("coach", {
      coachsession: "coachsession",
    }),
  },
};
</script>
